import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageService } from 'src/app/services/page.service';
import { SmartLabelService } from "./smart-label.service";

// Remaining Component Import here

@Component({
  selector: 'app-smart-label',
  templateUrl: './smart-label.component.html',
  styleUrls: ['./smart-label.component.scss']
})
export class SmartLabelComponent implements OnInit, OnDestroy {
  @Input() config;
  @Input() data;
  entityInformation: any = {};

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  constructor(private smartlabelService: SmartLabelService,
    private pageService: PageService) { }

  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {
    //console.log('SL init')
    //  console.log('SmartLabelComponent',this.config);
    //  console.log(this.smartLabelData);
    this.entityInformation = this.data.entityInformation;

    if (!this.config.template) {
      this.config.template = 'NON_FOOD';


      if (this.smartlabelService.isProductEntity) {
        if (this.entityInformation.hasOwnProperty('productCategory')) {
          this.config.template = this.entityInformation.productCategory; //isProductEntity
        }
      } else {

        if (this.pageService.smartLabelData.hasOwnProperty('product')) {

          if (this.pageService.smartLabelData.product.hasOwnProperty('productCategory')) {
            this.config.template = this.pageService.smartLabelData.product.productCategory;
          }
        }
      }


    }
    this.smartlabelService.setMetaTags();

    // console.log(this.config);
  }

  /**
   * onDestroy unset seo meta tags
   * @author Radhika Agnihotri
   * @task QLIKTAG-3032
   */
  ngOnDestroy() {
    this.smartlabelService.unsetMetaTags();
  }
}
